import Select, { components } from "react-select";
import { useEffect, useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { color } from "framer-motion";

const MobileSelect = ({
  options,
  selectedValues,
  onChange,
  placeholder,
  startIcon = undefined,
  menuplacement = "auto",
  ...props
}) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedValues || []);

  useEffect(() => {
    setSelectedOptions(selectedValues);
  }, [selectedValues]);

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowForwardIosIcon
          style={{ color: "#A098AE", width: 12, height: 24 }}
        />
      </components.DropdownIndicator>
    );
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    if (onChange) {
      onChange(selectedOptions);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#5D5FEF", // Selected option text color
      fontWeight: "400",
      fontSize: "1rem",
      fontFamily: "Poppins",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black", // Placeholder text color
      fontWeight: "400",
      fontSize: "1rem",
      fontFamily: "Poppins",
    }),
    menu: (provided) => ({
      ...provided,
      width: "100%",
      color:"black",
    }),
  };

  return (
    <div
      className={`d-flex align-items-center w-100 border border-sm`}
      style={{
        borderRadius: "8px",
        backgroundColor: "white",
        padding:"0px 8px"
      }}
    >
      {startIcon ? startIcon : null}
      <div className={`w-100`}>
        <Select
          menuPlacement= {menuplacement}
          isSearchable={false}
          autosize={true}
          styles={customStyles}
          options={Array.isArray(options) ? options : []}
          placeholder={placeholder || "Select..."}
          value={selectedOptions}
          components={{
            DropdownIndicator, //postfix icon
          }}
          onChange={handleSelectChange}
          {...props}
        />
      </div>
    </div>
  );
};

export default MobileSelect;
